import { Reveal } from "./Reveal";
import { IMAGES } from "../data/site";

export const QuoteBand = () => (
  <section data-testid="quote-band" className="relative overflow-hidden">
    <img
      src={IMAGES.quote}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-[#383D33]/85" />
    <div className="grain relative mx-auto max-w-4xl px-5 py-24 text-center sm:px-8 sm:py-28">
      <Reveal>
        <span className="gold-hairline mx-auto block h-px w-24" />
        <p className="mt-8 font-brand text-2xl italic leading-snug text-[#F2EFE6] sm:text-3xl lg:text-4xl">
          &ldquo;Where every woman leaves a little more herself: confident, radiant,
          renewed.&rdquo;
        </p>
        <p className="mt-6 font-body text-xs font-medium uppercase tracking-[0.35em] text-[#C9A24B]">
          The Her Styles Promise
        </p>
        <span className="gold-hairline mx-auto mt-8 block h-px w-24" />
      </Reveal>
    </div>
  </section>
);
